import React from 'react';
import { Card, CardBody } from 'reactstrap';

//Scripts auxiliares:
import { flipArray, cleanUndefineds } from '../../../tools/scripts/arrayManagement';
//import { timeoutFetch } from '../../../tools/scripts/customFetching';
import InteractiveProcess from './InteractiveProcess';

let dateFormatter = require('../../../tools/formatters/dateFormatter');

function ProcessTimeline(props) {
    return (
        <Card className="card card-timeline card-plain">
            <CardBody style={{ minHeight: 325, maxHeight: 325, padding: 10, margin: 15 }} className="card-without-scrollbar">
                <ul className="timeline" style={{ paddingBottom: 0, marginBottom: 0 }}>
                    {getTimelineItems(props.processDetail, props.targetProcess, props.getTimelineIconClassname, props.getTimelineDivClassname)}
                </ul>
            </CardBody>
        </Card>
    );
}

let cleanRepeatedSFTPItems = (originalLog) => {
    let cleanedArray = [];
    let noUndefinedsArray = cleanUndefineds(originalLog);

    let sftpItemFound = false;
    for (let i = noUndefinedsArray.length - 1; i >= 0; i--) {
        if (noUndefinedsArray[i].name.includes("SFTP")) {
            if (!sftpItemFound) {
                sftpItemFound = true;
                cleanedArray.push(noUndefinedsArray[i]);
            }
        } else {
            cleanedArray.push(noUndefinedsArray[i]);
        }
    }

    return flipArray(cleanedArray);
}

let getAdjustedLogWithStartAndFinish = (originalLog, associatedProcess) => {
    let targetLog = [];

    targetLog.push(...(originalLog.map((logItem, i) => {
        //console.log(`logItem  -- ${JSON.stringify(logItem)}`);
        if (logItem.show_detail) { return (logItem); } return undefined;
    })));

    return cleanRepeatedSFTPItems(targetLog);
}

/*let sendCaptcha = (e, props) => {
    e.preventDefault();
    document.body.style.cursor = "wait";
    document.getElementById('labelErrorDelSistema').hidden = true;
    document.getElementById('labelCredencialesIncorrectas').hidden = true;

    timeoutFetch(process.env.REACT_APP_API_URL + "/generateAuthToken/", {
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: e.target.email.value, password: e.target.password.value })
    }, 5000)
        .then(serverResponse => {
            document.body.style.cursor = "default";
            switch (serverResponse.status) {
                case 200:
                    serverResponse.json().then(loggedUser => {
                        localStorage.setItem("lastLoggedUser", JSON.stringify(loggedUser));
                        this.getUserInfoAndLogin(loggedUser, props);
                    });
                    break;

                case 400:
                    // console.log('Credenciales incorrectas');
                    document.body.style.cursor = "default";
                    document.getElementById('labelCredencialesIncorrectas').hidden = false;
                    break;

                default:
                    console.log('Error del sistema');
                    document.body.style.cursor = "default";
                    document.getElementById('labelErrorDelSistema').hidden = false;
                    break;
            }

        })
        .catch(error => {
            console.log(error);
            document.body.style.cursor = "default";
            document.getElementById('labelErrorDelSistema').hidden = false;
        });
}*/

let getTimelineItems = (processDetail, targetProcess, getTimelineIconClassname, getTimelineDivClassname) => {
    let timelineItems = [];
    let processLog = getAdjustedLogWithStartAndFinish(processDetail, targetProcess);
    //console.log(`processLog  -- ${JSON.stringify(processLog)}`);
    for (let i = processLog.length; i >= 0; i--) {
        try {
            timelineItems.push(
                <li className="timeline-inverted" key={"itemDeProceso." + i + "." + (new Date().getSeconds())}>
                    <div className={"timeline-badge " + getTimelineDivClassname(processLog[i])}>
                        {getTimelineIconClassname(processLog[i])}
                    </div>
                    <div className="timeline-panel">
                        <div className="timeline-heading">
                            <b>{processLog[i].description}</b>
                        </div>
                        {

                             processLog[i].name.toUpperCase() === 'WAITING_CAPTCHA' &&
                                 <InteractiveProcess processLog={processLog[i]} ></InteractiveProcess>                             
                        }
                        <p className="category" style={{ textTransform: "none" }}>
                            {dateFormatter.getShortDate(new Date(processLog[i].created)) + " a las " + dateFormatter.getShortHour(new Date(processLog[i].created))}
                        </p>
                    </div>
                </li>
            );
        }
        catch (error) { }
    }

    return timelineItems;
}

export default ProcessTimeline;